import { Component, OnDestroy, OnInit } from '@angular/core';
import { DriversService } from '../../drivers-service/drivers-service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-driver-shift-override-list',
  templateUrl: './driver-shift-override-list.component.html',
  styleUrls: ['./driver-shift-override-list.component.css']
})
export class DriverShiftOverrideListComponent implements OnInit, OnDestroy {
  shiftOverrideList = [];
  search: any;
  driverId;
  todayDate: any = [];
  timeZone;
  user;
  driverDetails;
  selectedStatus = 'active'

  constructor(
    private driverService: DriversService,
    private activatedRoute: ActivatedRoute,
    private sharedDataService: SharedDataService
  ) { }


  ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 4) {
      this.driverId = this.activatedRoute.snapshot.url[2].path;
    }

    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.timeZone = this.user.timeZone;
          this.todayDate = [
            moment().tz(this.timeZone).startOf('day').toISOString(),
            moment().tz(this.timeZone).add('days', 7).endOf('day').toISOString()
          ];

          if (this.driverId) {
            this.getDriverDetails();
          } else {
             this.getShiftOverrides();
          }
        }
      });
  }

  getDriverDetails() {
    this.driverService
      .getDriversByID(this.driverId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverDetails = data;
          this.getShiftOverrides();
        }
      });
  }

  getShiftOverrides() {
    let payload: any = {
      startDate: moment(this.todayDate[0]).tz(this.timeZone).toISOString(),
      endDate: moment(this.todayDate[1]).tz(this.timeZone).toISOString(),
      status: this.selectedStatus

    }
    let queryParams = {
      status: this.selectedStatus
    }

    if (this.driverDetails) {
      payload.driverIds = [this.driverId];
    }

    this.driverService.getShiftOverridesByDate(payload).pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.shiftOverrideList = data;
        }
      });
  }


  onDateChange(event) {
    this.todayDate = [
      moment(event[0]).toISOString(),
      moment(event[1]).endOf('day').toISOString()
    ];
    this.getShiftOverrides();
  }

  onDelete(i){
     sweetAlert(
          "Alert",
          "Are you sure you want to remove this shift?",
          "warning",
          "Yes",
          "No"
        ).then((result: any) => {
          if (result.value) {
          const item = this.shiftOverrideList[i];
    this.driverService.deleteShiftOverride(item._id).pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.shiftOverrideList.splice(i, 1);
        }
      });
          }
        });
   
  }

    onChangeStatus() {
    this.shiftOverrideList = [];
    this.getShiftOverrides();
  }

  ngOnDestroy(): void {
  }

}
